import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostEdc_sharing_groupIdOptimize = z.any()
export type TagsPostEdc_sharing_groupIdOptimize = z.infer<typeof tagsPostEdc_sharing_groupIdOptimize>

export const paramsPostEdc_sharing_groupIdOptimize = z.object({ "groupId": z.string() })
export type ParamsPostEdc_sharing_groupIdOptimize = z.infer<typeof paramsPostEdc_sharing_groupIdOptimize>

export const bodyPostEdc_sharing_groupIdOptimize = z.object({ "from": z.string().date().optional(), "to": z.string().date().optional() })
export type BodyPostEdc_sharing_groupIdOptimize = z.infer<typeof bodyPostEdc_sharing_groupIdOptimize>

export const responsePostEdc_sharing_groupIdOptimize = z.object({ "payload": z.object({ "totals": z.object({ "generation": z.number(), "consumption": z.number(), "shared": z.number(), "received": z.number(), "exported": z.number(), "purchased": z.number(), "missed": z.number() }), "points": z.array(z.object({ "key": z.string(), "shared": z.number() })), "keys": z.record(z.number().gte(0).lte(1)).superRefine((value, ctx) => {
for (const key in value) {
if (key.match(new RegExp("^(.*)$"))) {
const result = z.number().gte(0).lte(1).safeParse(value[key])
if (!result.success) {
ctx.addIssue({
          path: [...ctx.path, key],
          code: 'custom',
          message: `Invalid input: Key matching regex /${key}/ must match schema`,
          params: {
            issues: result.error.issues
          }
        })
}
}
}
}), "improvement": z.number(), "better": z.boolean() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostEdc_sharing_groupIdOptimize = z.infer<typeof responsePostEdc_sharing_groupIdOptimize>

interface IPostEdc_sharing_groupIdOptimize extends BaseMethodType {
  tags: TagsPostEdc_sharing_groupIdOptimize,
  params: ParamsPostEdc_sharing_groupIdOptimize,
  body: BodyPostEdc_sharing_groupIdOptimize,
  response: ResponsePostEdc_sharing_groupIdOptimize
}
export const URL = '/edc-sharing/:groupId/optimize'
export const validation = {
  post: {
    tags: tagsPostEdc_sharing_groupIdOptimize,
    params: paramsPostEdc_sharing_groupIdOptimize,
    body: bodyPostEdc_sharing_groupIdOptimize,
    response: responsePostEdc_sharing_groupIdOptimize
  }
}
export interface Edc_sharing_groupIdOptimize extends BaseRouteType {
  post: IPostEdc_sharing_groupIdOptimize
}